<ng-container [formGroup]="form">
  <h4 class="d-inline-block">Referrer Arrangement</h4>

  <div class="row">
    <div class="col">
      <spark-shared-yes-or-no-question
        formControlName="available"
        identifier="{{ identifier }}_available"
        label="Was this contact via a referrer?"
        [isRequired]="true">
      </spark-shared-yes-or-no-question>
    </div>
  </div>

  <div class="row" *ngIf="form.value.available">
    <div class="col-12">
      <spark-contacts-referrer-arrangement-form
        identifier="{{ identifier }}_form"
        formControlName="value"
        [schema]="schema">
      </spark-contacts-referrer-arrangement-form>
    </div>
  </div>
</ng-container>
